// Modelo Compañia para administrador.
export default class Company {
    id=""
    code=""
    name=""
    address=""
    phone=""
    agent=""
    ciiu={}
    observation=""
    costCenter=""
    status=true
}



// WEBPACK FOOTER //
// ./src/model/Company.js